export const createAuthTokenHeader = (token) => ({ Authorization: `Bearer ${token}` });
